import { LoginView } from "../VIEW/LoginView";
import { LoggedInView } from "../VIEW/LoggedInView";
import { useAuth } from "../FIREBASE/useAuth";

function LoginPage() {
  const { user, loading } = useAuth();

  if (loading) return null;
  if (user) return <LoggedInView />;
  return <LoginView />;
}

export default LoginPage;
